import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getOpinionsList} from '../services/getOpinionsList';

export const useGetOpinionsListQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.HOSPITALIZATION_OPINIONS_LIST],
		queryFn: ({signal}) => getOpinionsList(signal),
	});
